module.exports = __webpack_public_path__ + "img/MERCEDES AMG.84478b7.jpg";